import { MessageCircle, Mail } from 'lucide-react';

import { cn } from '@/lib/cn';

// La app está escrita sólo en español: se fija `lang=es` para que la página
// legal no cambie de idioma según el navegador.
const LEGAL_BASE = 'https://legal.urbania3d.app';
const LEGAL_LANG = 'es';
export const LEGAL_PRIVACY_URL = `${LEGAL_BASE}/privacy?lang=${LEGAL_LANG}`;
export const LEGAL_TERMS_URL = `${LEGAL_BASE}/terms?lang=${LEGAL_LANG}`;
export const SUPPORT_WHATSAPP_URL = 'https://wa.link/19qd7m';
export const SUPPORT_EMAIL = 'urbania3d.app@gmail.com';

const linkClass =
  'cursor-pointer rounded-control underline-offset-4 outline-none transition-colors hover:text-brand-ink hover:underline focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-canvas';

/**
 * Privacidad y términos. Las páginas son las mismas para todos los
 * productos de Urbania y viven en `legal.urbania3d.app`; acá sólo se
 * enlazan. Abre en pestaña nueva para no sacar a nadie de un formulario
 * a medio llenar.
 */
export function LegalLinks({ className }: { className?: string }) {
  return (
    <p className={cn('text-center text-xs text-ink-2', className)}>
      <a href={LEGAL_PRIVACY_URL} target="_blank" rel="noopener noreferrer" className={linkClass}>
        Privacidad
      </a>
      <span aria-hidden="true"> · </span>
      <a href={LEGAL_TERMS_URL} target="_blank" rel="noopener noreferrer" className={linkClass}>
        Términos
      </a>
    </p>
  );
}

/** Contacto de soporte: WhatsApp y correo. */
export function SupportLinks({ className }: { className?: string }) {
  return (
    <div className={cn('flex flex-wrap items-center gap-x-5 gap-y-2 text-sm', className)}>
      <a
        href={SUPPORT_WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={cn(linkClass, 'inline-flex items-center gap-1.5 font-medium text-ink-2')}
      >
        <MessageCircle className="h-4 w-4" aria-hidden="true" />
        WhatsApp
      </a>
      <a
        href={`mailto:${SUPPORT_EMAIL}`}
        className={cn(linkClass, 'inline-flex items-center gap-1.5 font-medium text-ink-2')}
      >
        <Mail className="h-4 w-4" aria-hidden="true" />
        {SUPPORT_EMAIL}
      </a>
    </div>
  );
}
